<template>
  <v-app>

    <v-app-bar app dark color="red darken-3">

      <!-- Note the '$router.push' pattern instead of using 'to' to avoid some undesirable styling -->
      <v-btn @click="$router.push({ name: 'home' })" icon v-if="$router.currentRoute.name !== 'home'">
        <v-icon>mdi-home</v-icon>
      </v-btn>
      
      <v-spacer />
      <v-toolbar-title class="font-script app-title">Workout Roulette</v-toolbar-title>
      <v-spacer />
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>

    <v-footer app fixed dark color="red darken-3">
      <v-btn @click="$router.push({ name: 'about' })" text>About</v-btn>
      <v-spacer />
      <div>&copy; {{ new Date().getFullYear() }}</div>
    </v-footer>

  </v-app>
</template>

<style>
html {
  background-color: #C62828;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: hidden;
}

.font-script {
  font-family: 'Dancing Script', cursive;
}

.font-script.app-title {
  font-size: 36px !important;
}
</style>

<script>
export default {
  name: 'app',
  mounted() {
    // TODO: wrap this functionality up into a directive

    // Disable scrolling on the body if the window is taller than this - this is particularly important to disable the scroll bounce on mobile
    const SCROLL_MAX_HEIGHT_PX = 550;

    function preventDefault(e) {
      e.preventDefault();
    }

    // Vuetify sets a min-height of '100vh' on the 'v-app' component. This doesn't work well with mobile browsers, because the collapsible address bar is not included as part of that height, thus an app that has a height of exactly '100vh' will actually be scrollable, which is counter-intuitive. This method sets the min-height directly from the window.
    function resize() {
      const vApp = document.getElementsByClassName('v-application--wrap')[0];
      vApp.style['min-height'] = window.innerHeight + 'px';

      if (window.innerHeight > SCROLL_MAX_HEIGHT_PX) {
        document.body.addEventListener('touchmove', preventDefault, { passive: false });
      } else {
        document.body.removeEventListener('touchmove', preventDefault);
      }
    }
    resize();
    window.addEventListener('resize', resize);
  }
}
</script>
